import { MyProfileState } from './types'

export const initialState: MyProfileState = {
  profile: undefined,
  isProfileLoading: false,
  isProfileLoaded: false,
  isProfileLoadingFailed: false,
  hasUploadingImageSuccess: false,
  isUploadingImageLoading: false,
  hasUploadingImageFailed: false,
  notifications: [],
}
